export const registerServiceWorker = (): void => {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    const publicPath = process.env.PUBLIC_URL || "";
    navigator.serviceWorker.register(`${publicPath}/service-worker.js`).catch(() => {
      // The app remains usable online if service-worker registration is unavailable.
    });
  });
};
